import BarSegmentChart from './bar-segment-chart';

export default BarSegmentChart;
